import { render, staticRenderFns } from "./TemplateMessagePreview.vue?vue&type=template&id=28a1b732&scoped=true&"
import script from "./TemplateMessagePreview.vue?vue&type=script&lang=js&"
export * from "./TemplateMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMessagePreview.vue?vue&type=style&index=0&id=28a1b732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a1b732",
  null
  
)

export default component.exports